import React, { useState } from "react";

const Star = ({ rating }) => {
  return (
    <div style={{ display: "flex" }}>
      {Array.from({ length: 5 }).map((_, index) => {
        const starValue = index + 1;
        let starFill;

        if (starValue <= rating) {
          starFill = "gold";
        } else if (starValue - rating === 0.5) {
          starFill = "half";
        } else {
          starFill = "gray";
        }

        if (starValue === Math.ceil(rating) && rating % 1 !== 0) {
          const decimalPart = rating % 1;
          const gradientId = `starGradient${index}`;

          return (
            <span key={index}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <defs>
                  <linearGradient
                    id={gradientId}
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="0%"
                  >
                    <stop offset={`${decimalPart * 100}%`} stopColor="gold" />
                    <stop offset={`${decimalPart * 100}%`} stopColor="gray" />
                  </linearGradient>
                </defs>
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                  fill={`url(#${gradientId})`}
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                />
              </svg>
            </span>
          );
        }

        return (
          <span key={index}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                fill={starFill}
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
              />
            </svg>
          </span>
        );
      })}
    </div>
  );
};

export default Star;
